<template>
  <v-container fill-height fluid pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;">
    <v-row class="fill-height white--text" no-gutters>
      <v-col class="align-self-start" cols="12">
        <top-bar>
          <template v-slot:logos>
            <v-row class="fill-height flex-nowrap pt-6 pl-6" no-gutters>
              <v-col class="flex-shrink-1 pr-4" cols="auto">
                <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
              </v-col>
              <v-col class="flex-shrink-1 " cols="auto">
                <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>
              </v-col>
            </v-row>
          </template>
          <template v-slot:title>CEO for a Day</template>
          <template v-slot:info>
            <v-row class="pt-8 pr-8" justify="end" no-gutters>
              <v-btn dark icon x-large @click="$router.replace(`/${$route.params.app}/menu`)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
          </template>
        </top-bar>
        <v-row align="center" class="py-12 pa-4">
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/concern_of_global_ceo.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/most_important_factors.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <div class="font-weight-bold text-center">
              <small>
                Source: PWC global survey on technology, jobs and skills
              </small>
            </div>
            <v-img contain max-height="180" src="@/assets/images/ceo_info_1_2.svg"></v-img>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/impact_of_emerging_technologies.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <share-of-total-power class="mb-4"></share-of-total-power>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <top-growth-strategies></top-growth-strategies>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/adaptation_of_nextgen.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/companies_with_more_diverse.json')"></highcharts>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="white--text"
         style="position: fixed; bottom: 0; height: 60px; width: 100%; background-color: #1D4162;">
      <stocks-ticker :stock-data="stockData"></stocks-ticker>
    </div>
  </v-container>
</template>

<script>
import TopBar from "@/components/Framework/TopBar";
import StocksTicker from "@/components/CeoForADay/StocksTicker";
import stockData from '@/assets/text/stock_data.json';
import questions from '@/assets/text/ceo_for_a_day_questions.json'
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import DataModule from 'highcharts/modules/data';
import TopGrowthStrategies from "@/views/Tools/Maaden/Components/TopGrowthStrategies";
import ShareOfTotalPower from "@/views/Tools/Maaden/Components/ShareOfTotalPower";

DataModule(Highcharts);

export default {
  name: "CeoForADay",
  components: {
    TopBar,
    StocksTicker,
    highcharts: Chart,
    TopGrowthStrategies,
    ShareOfTotalPower
  },
  data: () => ({
    tableData: null,
    infographicOne: null,
    infographicTwo: null,
    stockData: null,
    questions: []
  }),
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {
    this.tableData = require('@/assets/tables/international_labour_organization.json');
    this.tableData2 = require('@/assets/tables/global_covid_19_statistic.json');
    this.infographicOne = require('@/assets/infographics/pwc_global_survey.json');
    this.infographicTwo = require('@/assets/infographics/global_internet.json');
    this.stockData = stockData;
    this.questions = questions;
  }
}
</script>

<style scoped>
tbody tr:hover {
  background-color: transparent !important;
}

table, th, td {
  border: 1px solid white;
}
</style>